var detect = avm.require('avast.detect');
var detecting = detect();

$(document).ready(function(){
    if (detecting.browser.isIternetExplorer || detecting.browser.isEdge) {
        $('body').addClass('br-internet-explorer');
    }

    if (detecting.browser.isFirefox && parseInt(detecting.browser.version) < 52) {
        $('body').addClass('br-firefox');
    }

    if (detecting.browser.isSafari) {
        $('body').addClass('br-safari');
    }
});

$(document).ready(function(){
    $('.bio-items div').css('display', false);
    $('.bio-items .mng-item').css('display', 'none');

    $('.team-items a').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();

        var href = $(this).attr('href');
        $('.bio, .video-modal').removeClass('active');
        $('body').toggleClass('overlay-active');
        if ($('[rel="' + href.replace('#', '') + '"] .close').length === 0) {
            $('[rel="' + href.replace('#', '') + '"]').append('<div class="close"></div>');
        }

        $('[rel="' + href.replace('#', '') + '"]').toggleClass('active');

        $('.destroyer, [rel="' + href.replace('#', '') + '"] .close').on('click', function(e){
            $('.bio, .video-modal').removeClass('active');
            $('body').removeClass('overlay-active');            
        });
    });
});

$(document).ready(function(){
    $("#milestones-timeline").on('click', function(){
        // $.colorbox({top: $(this).position().top - 320 , width:"80%", height: $("#timeline").innerHeight(), html : $("#timeline").html() });
    });
    if(window.location.href.indexOf("milestones-timeline-popup") > -1) {
		$("#milestones-timeline").click();
	}
});


$(document).ready(function(){
    var mediaQuery = function () {
        var _scrn = (window.getComputedStyle) ? window.getComputedStyle(document.body, ':after').getPropertyValue('content') : '';
        if (_scrn === '\'mobile\'' || _scrn === "\"mobile\"" || _scrn === "mobile" || _scrn === '\'tablet\'' || _scrn === "\"tablet\"" || _scrn === "tablet") {
            return true;
        }
    }

    var setVideoModal = function () {
        $('.play').click(function(e){
            if (!mediaQuery()) {
                e.preventDefault();
                e.stopPropagation();

                var src = $(this).data('src');


                $('.bio, .video-overlay').removeClass('active');
                $('body').toggleClass('overlay-active');
                $('.video-overlay .inner').append(' <iframe width="800" height="460" src="' + src + '" frameborder="0" allowfullscreen></iframe>')

                $('.video-overlay').toggleClass('active');

                $('.destroyer, .video-overlay .close').on('click', function(e){
                    $('.bio, .video-overlay').removeClass('active');
                    $('body').removeClass('overlay-active');
                    $('.video-overlay .inner').empty();
                });
            }
        });
    }

    setVideoModal();

    $(window).on('resize', function(){
        if (mediaQuery()) {
            if ($('.video-overlay.active').length > 0) {
                $('body').removeClass('overlay-active');
                $('.video-overlay').removeClass('active');
            }
        }
    });
});


$(document).ready(function () {
    $('ul.tabs li').on('click', function () {
        var tab_id = $(this).attr('data-tab');       

        $('ul.tabs li').not('[data-tab='+tab_id+']').removeClass('current');
        $('.tab-content:not(.'+tab_id+')').removeClass('current');

        $(this).addClass('current');
        $("#" + tab_id).addClass('current');   
    });
});

(function() {

    if ($('.map-attacks').length == 0) return;

    var totalPointsCount = $('.map-attacks__point').length,
        pulseAnimation = 1500;

    setInterval(function() {
        showPoint();
    }, 25);

    function showPoint() {
        var $availablePoints = $('.map-attacks__point').not('.anim');
        var availablePointsCount = $availablePoints.length;
        animate($availablePoints.eq(randomNumber(1, availablePointsCount)));
    }

    function animate($element) {
        $element.show();
        setTimeout(function() {
            $element.addClass('anim');
        }, 0);
        setTimeout(function() {
            $element.addClass('pulse');
        }, 0);
        setTimeout(function() {
            $element.removeClass('pulse').fadeOut(1000, function() {
                $element.removeClass('anim');
            });
        }, pulseAnimation - 500);
    }

    function randomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

})();

(function ($) {
    'use strict';
    var topHeight,
        topWidth,
        ratio,
        $video = $('#js-video'),
        video = document.querySelector('#js-video'),
        int = setInterval(function () {
        }, 500),
        connectionSpeedResult,
        /**
        * Video background
        * @version 0.0.1
        * @author Michal Langhoffer
        * @copyright AVAST
          Software s.r.o.
        */
        vbg = {
            /**
            * Calculating connection speed
            * @returns {number}
            */
            connectionSpeed: function () {
                var now = new Date().getTime(),
                    page_load_time = now - performance.timing.navigationStart;
                connectionSpeedResult = page_load_time;
                return connectionSpeedResult;
            },
            /**
            * Get screen size
            * @returns {boolean}
            */
            mediaQuery: function () {
                var _scrn = (window.getComputedStyle) ? window.getComputedStyle(document.body, ':after').getPropertyValue('content') : '';
                if (_scrn === '\'mobile\'' || _scrn === "\"mobile\"" || _scrn === "mobile") {
                    return true;
                }
            },
            /**
            * Scale video according to screen ratio
            */
            videoScale: function () {
                topHeight = $('#top').height();
                topWidth = $('#top').width();
                ratio = topWidth / topHeight;
                if (ratio < (16 / 9) || topWidth < 1921) {
                    $video.css({
                        'width' : 'auto',
                        'height' : '100%'
                    });
                } else {
                    $video.css({
                        'width' : '100%',
                        'height' : 'auto'
                    });
                }
            },
            /**
            * Disable preload for other devices than desktops with removing its source path
            */
            preloadDisable: function () {
                $video.attr('src', '');
            },
            /**
            * Enable preload for other devices than mobiles/tablets when resizing from mobile to desktop - by if statement I am preventing reloading of video when resize on desktops
            */
            preloadEnable: function () {
                var _attr = $video.attr('src');
                if (typeof _attr !== typeof undefined && _attr !== false) {
                    $video.removeAttr('src');
                }
            },
            /**
            * Check loading of video states, on state 4 set preloading time
            * @returns {number}
            */
            checkVideoLoad: function () {
                function checkLoad() {
                    if (video.readyState === 4) {
                        setTimeout(function () {
                            var v1 = video.buffered.end(0);
                            setTimeout(function () {
                                var v2 = video.buffered.end(0);
                            }, 1000);
                            return v1;
                        }, 2000);
                        clearInterval(int);
                        // set preload time
                        setTimeout(
                            function () {
                                video.play();
                            },
                            vbg.preloadTimeCounter()
                        );
                    } else {
                        setTimeout(checkLoad, 100);
                    }
                }
                checkLoad();
            },
            /**
            * Calculate time to pause video for preload from duration of video and connection speed
            * @returns {number}
            */
            preloadTimeCounter: function () {
                var _duration = document.getElementById('js-video').duration,
                    result = function () {
                        return Math.round((connectionSpeedResult / 1000) * (_duration / 10)) * 300;
                    };
//                return result();
                return 0;
            }
        };
    vbg.videoScale();
    vbg.connectionSpeed();
    video.pause();

    // true = mobile/tablet resolution
    if (vbg.mediaQuery()) {
        vbg.preloadDisable();
    } else {
        vbg.preloadEnable();
    }


    $(window).resize(function () {
        vbg.videoScale();

        // true = mobile/tablet resolution
        if (vbg.mediaQuery()) {
            vbg.preloadDisable();
        } else {
            vbg.preloadEnable();
        }
    });

    window.addEventListener('load', vbg.checkVideoLoad(), false);

})(jQuery);
